import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';

import s from './ToolHeading.css';
import Tooltip from '../Tooltip';

const ToolHeading = ({ headingText, detailText, url }) => {
  const content = (
    <div>
      <Grid fluid={false}>
        <Row>
          <Col md={12}>
            <div className={s.heading}>
              <h1
                style={{
                  fontSize: '50px',
                  fontWeight: 'normal',
                  paddingBottom: '10px',
                }}
              >
                {headingText}
              </h1>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6} mdOffset={3}>
            <div className={s.headingBottom}>
              <p className="lead">
                {detailText}
                <Tooltip
                  text={`Documentation for ${headingText.toLowerCase()}`}
                >
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    <i className={`fa fa-book fa-fw ${s.infoIcon}`} />
                  </a>
                </Tooltip>
              </p>
            </div>
          </Col>
        </Row>
      </Grid>
    </div>
  );
  return content;
};

ToolHeading.propTypes = {
  detailText: PropTypes.string.isRequired,
  headingText: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default withStyles(s)(ToolHeading);
